<template>
  <div class="CategoryComponent">
      
    <v-select size="sm" :options="listCategory"  placeholder="Choose categories..." v-model="selected"></v-select>
    
    
 </div>
</template>

<script>
//import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

export default {
  name: 'CategoryComponent',
  components: {
    vSelect
  },
  props:{
    data: Object,
    lang: Object
  },
  data () {
    return {
      listCategory: [],
      fullList: [],
      id: "treecombo_"+this._uid,
      selected: "All components",
      selectedCategoryId: 1
    }
  },
  computed: {
    view(){
      return this.$store.getters.viewForModule;
    }

  },
  created () {
    
    
    if (this.$store.getters.selectedTreeItemObject.category != undefined){
      this.selected = this.$store.getters.selectedTreeItemObject.category;
    }
    if (this.$store.getters.selectedTreeItemObject.categoryId != undefined){
      this.selectedCategoryId = this.$store.getters.selectedTreeItemObject.categoryId;
    }
    
    
    let vue = this;
    

    this.$store.dispatch(this.$store.getters.sectionPrefix + '_getFlatCategories')
    .then((result)=>{ 
        console.log(result.data)
        vue.createList(result.data);

        if (vue.$store.getters.sectionPrefix == "lm"){
            vue.selected = "All libraries";
        }
        if (vue.$store.getters.sectionPrefix == "pm"){
            vue.selected = "All components";
        }
            
    })


  },
  updated() {
    
    
  },
  watch: {
    view: function(newVal, oldVal){
      
      
      
      if (this.$store.getters.selectedTreeItemObject.category != undefined){
        this.selected = this.$store.getters.selectedTreeItemObject.category;
      }
      if (this.$store.getters.selectedTreeItemObject.categoryId != undefined){
        this.selectedCategoryId = this.$store.getters.selectedTreeItemObject.categoryId;
      }
    },
    selected: function(newVal, oldVal){
      

      if (newVal != undefined){
        for (let i = 0, lei = this.listCategory.length; i < lei; i++){
          if (this.listCategory[i] == newVal){
            this.selectedCategoryId = this.fullList[i].categoryId;
            
            break;
          }
        }

        const obj = {
          categoryId: this.selectedCategoryId,
          category: this.selected,
          
        }
       
        this.$store.dispatch('selectTreeItemObject', obj);
        
      }else{
        //this.selectedCategoryId = 1;

      }     

      



    },

  },
  methods: {
    createList: function(categories){
      
      const obj = {
        category: categories.category,
        categoryId: categories.categoryId
      }
      this.listCategory.push(categories.category);
      this.fullList.push(obj);

      if (categories.children.length > 0){
        this.categoriesChildren(categories.children);
      }



    },
    categoriesChildren: function (children){

      for (var i = 0, lei = children.length; i < lei; i++){

        const obj = {
          category: children[i].category,
          categoryId: children[i].categoryId
        }



        this.listCategory.push(children[i].category)
        this.fullList.push(obj)


        if (children[i].children.length > 0){
          this.categoriesChildren(children[i].children);
        }

      }
    }
  }
}
</script>


<style lang="scss">
  .CategoryComponent{
    .v-select input[type="search"] {
      
      width: 100% !important;
    }
    .clear{
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/CategoryComponent.vue